export const AlertLogo = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="16"
            viewBox="0 0 16 17"
            fill="none"
            data-testid="alert-logo">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.0046 12.9381C11.6322 13.2781 11.059 13.4926 10.4836 13.5399C9.23404 13.6423 8.04868 13.5574 6.81821 13.7011C6.58035 13.7289 6.32393 13.4616 6.25407 13.1784C6.05138 12.3556 6.59748 12.2215 7.19497 12.1532C8.39444 12.0161 9.61388 11.9165 10.8213 11.7945C11.1342 11.7629 11.4355 11.7091 11.7382 11.6585C11.9132 11.6294 11.7563 11.9863 11.9058 12.134C12.0604 12.2868 12.0002 11.901 12.2093 12.0945C12.3536 12.228 12.1781 12.7652 12.0046 12.9381Z"
                fill="#1D1D1B"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.2585 4.61111C4.53442 4.72879 4.79225 5.30218 4.69941 5.7079C4.49755 6.58909 4.16095 7.62736 3.99264 8.49644C3.9601 8.66444 3.56653 8.78197 3.35027 8.82203C2.72202 8.93821 2.74688 8.55026 2.82965 8.12829C2.99592 7.28121 3.19311 6.42128 3.3718 5.56911C3.41812 5.34823 3.44617 5.13483 3.47673 4.92057C3.49456 4.79665 3.6061 4.692 3.7437 4.59168C3.88611 4.4879 3.96113 4.78719 4.04346 4.82519C4.18993 4.89269 4.0546 4.52415 4.2585 4.61111Z"
                fill="#1D1D1B"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.6722 4.93349C10.6552 5.06308 10.5128 5.04581 10.624 5.09525C10.6887 5.12393 10.6202 5.2455 10.7562 5.25999C10.8922 5.27448 10.6671 6.24664 10.296 6.54876C8.7902 7.77575 7.51612 9.555 6.07168 10.9282C5.97008 11.0249 5.87191 11.1301 5.77084 11.2281C5.46956 11.4394 5.27501 11.243 5.04263 10.958C4.64183 10.4663 4.90689 10.018 5.46305 9.3172C6.61848 7.86122 7.77858 6.41299 8.97857 5.0416C9.35275 4.61379 9.74869 4.23493 10.2116 4.2033C10.3356 4.19468 10.4625 4.20398 10.576 4.24706C10.6755 4.28504 10.7968 4.35963 10.7698 4.55316C10.7417 4.75416 10.6885 4.69807 10.5967 4.72532C10.5128 4.75038 10.6869 4.82235 10.6722 4.93349Z"
                fill="#1D1D1B"
            />
        </svg>
    );
};
